import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_CONDITIONS',
  'FETCH_CONDITIONS_START',
  'FETCH_CONDITIONS_SUCCESS',
  'FETCH_CONDITIONS_ERROR',
  'FETCH_CONDITION',
  'FETCH_CONDITION_START',
  'FETCH_CONDITION_SUCCESS',
  'FETCH_CONDITION_ERROR',
  'FETCH_ENCOUNTERS',
  'FETCH_ENCOUNTERS_START',
  'FETCH_ENCOUNTERS_SUCCESS',
  'FETCH_ENCOUNTERS_ERROR',
  'FETCH_PATIENTS',
  'FETCH_PATIENTS_START',
  'FETCH_PATIENTS_SUCCESS',
  'FETCH_PATIENTS_ERROR',
  'FETCH_PATIENT',
  'FETCH_PATIENT_START',
  'FETCH_PATIENT_SUCCESS',
  'FETCH_PATIENT_ERROR',
  'FETCH_IMMUNIZATIONS',
  'FETCH_IMMUNIZATIONS_START',
  'FETCH_IMMUNIZATIONS_SUCCESS',
  'FETCH_IMMUNIZATIONS_ERROR',
  'FETCH_IMMUNIZATION',
  'FETCH_IMMUNIZATION_START',
  'FETCH_IMMUNIZATION_SUCCESS',
  'FETCH_IMMUNIZATION_ERROR',
  'FETCH_OBSERVATIONS',
  'FETCH_OBSERVATIONS_START',
  'FETCH_OBSERVATIONS_SUCCESS',
  'FETCH_OBSERVATIONS_ERROR',
  'FETCH_OBSERVATION',
  'FETCH_OBSERVATION_START',
  'FETCH_OBSERVATION_SUCCESS',
  'FETCH_OBSERVATION_ERROR',
  'FETCH_PROCEDURES',
  'FETCH_PROCEDURES_START',
  'FETCH_PROCEDURES_SUCCESS',
  'FETCH_PROCEDURES_ERROR',
  'FETCH_PROCEDURE',
  'FETCH_PROCEDURE_START',
  'FETCH_PROCEDURE_SUCCESS',
  'FETCH_PROCEDURE_ERROR',
  'FETCH_SEQUENCES',
  'FETCH_SEQUENCES_START',
  'FETCH_SEQUENCES_SUCCESS',
  'FETCH_SEQUENCES_ERROR',
  'FETCH_SEQUENCE',
  'FETCH_SEQUENCE_START',
  'FETCH_SEQUENCE_SUCCESS',
  'FETCH_SEQUENCE_ERROR',
  'UPDATE_SEQUENCE',
  'UPDATE_SEQUENCE_START',
  'UPDATE_SEQUENCE_SUCCESS',
  'UPDATE_SEQUENCE_ERROR',
  'FETCH_DOCUMENT_REFERENCES',
  'FETCH_DOCUMENT_REFERENCES_START',
  'FETCH_DOCUMENT_REFERENCES_SUCCESS',
  'FETCH_DOCUMENT_REFERENCES_ERROR',
  'FETCH_DOCUMENT_REFERENCE',
  'FETCH_DOCUMENT_REFERENCE_START',
  'FETCH_DOCUMENT_REFERENCE_SUCCESS',
  'FETCH_DOCUMENT_REFERENCE_ERROR',
  'FETCH_MEDIA',
  'FETCH_MEDIA_START',
  'FETCH_MEDIA_SUCCESS',
  'FETCH_MEDIA_ERROR',
  'FETCH_PROCEDURE_REQUEST',
  'FETCH_PROCEDURE_REQUEST_START',
  'FETCH_PROCEDURE_REQUEST_SUCCESS',
  'FETCH_PROCEDURE_REQUEST_ERROR',
  'FETCH_MEDIUM',
  'FETCH_MEDIUM_START',
  'FETCH_MEDIUM_SUCCESS',
  'FETCH_MEDIUM_ERROR',
  'FETCH_PATIENT_VARIANTS',
  'FETCH_PATIENT_VARIANTS_START',
  'FETCH_PATIENT_VARIANTS_SUCCESS',
  'FETCH_PATIENT_VARIANTS_ERROR',
  'FETCH_PATIENT_MEDICATION_STATEMENTS',
  'FETCH_PATIENT_MEDICATION_STATEMENTS_START',
  'FETCH_PATIENT_MEDICATION_STATEMENTS_SUCCESS',
  'FETCH_PATIENT_MEDICATION_STATEMENTS_ERROR',
  'FETCH_PATIENT_MEDICATION_ADMINISTRATIONS',
  'FETCH_PATIENT_MEDICATION_ADMINISTRATIONS_START',
  'FETCH_PATIENT_MEDICATION_ADMINISTRATIONS_SUCCESS',
  'FETCH_PATIENT_MEDICATION_ADMINISTRATIONS_ERROR',
  'FETCH_PATIENT_MEDICATION_REQUESTS',
  'FETCH_PATIENT_MEDICATION_REQUESTS_START',
  'FETCH_PATIENT_MEDICATION_REQUESTS_SUCCESS',
  'FETCH_PATIENT_MEDICATION_REQUESTS_ERROR',
  'FETCH_PATIENT_MEDICATION_DISPENSE',
  'FETCH_PATIENT_MEDICATION_DISPENSE_START',
  'FETCH_PATIENT_MEDICATION_DISPENSE_SUCCESS',
  'FETCH_PATIENT_MEDICATION_DISPENSE_ERROR',
  'FETCH_FHIR_GRAPHQL',
  'FETCH_FHIR_GRAPHQL_START',
  'FETCH_FHIR_GRAPHQL_SUCCESS',
  'FETCH_FHIR_GRAPHQL_ERROR',
  'FETCH_DIAGNOSTIC_REPORTS',
  'FETCH_DIAGNOSTIC_REPORTS_START',
  'FETCH_DIAGNOSTIC_REPORTS_SUCCESS',
  'FETCH_DIAGNOSTIC_REPORTS_ERROR',
  'FETCH_QUESTIONNAIRES',
  'FETCH_QUESTIONNAIRES_START',
  'FETCH_QUESTIONNAIRES_SUCCESS',
  'FETCH_QUESTIONNAIRES_ERROR',
  'CREATE_QUESTIONNAIRE',
  'CREATE_QUESTIONNAIRE_START',
  'CREATE_QUESTIONNAIRE_SUCCESS',
  'CREATE_QUESTIONNAIRE_ERROR',
  'UPDATE_QUESTIONNAIRE',
  'UPDATE_QUESTIONNAIRE_START',
  'UPDATE_QUESTIONNAIRE_SUCCESS',
  'UPDATE_QUESTIONNAIRE_ERROR',
  'FETCH_QUESTIONNAIRE',
  'FETCH_QUESTIONNAIRE_START',
  'FETCH_QUESTIONNAIRE_SUCCESS',
  'FETCH_QUESTIONNAIRE_ERROR',
  'FETCH_QUESTIONNAIRE_RESPONSE',
  'FETCH_QUESTIONNAIRE_RESPONSE_START',
  'FETCH_QUESTIONNAIRE_RESPONSE_SUCCESS',
  'FETCH_QUESTIONNAIRE_RESPONSE_ERROR',
  'FETCH_REFERRAL_REQUEST',
  'FETCH_REFERRAL_REQUEST_START',
  'FETCH_REFERRAL_REQUEST_SUCCESS',
  'FETCH_REFERRAL_REQUEST_ERROR',
  'FETCH_SPECIMEN_REQUEST',
  'FETCH_SPECIMEN_REQUEST_START',
  'FETCH_SPECIMEN_REQUEST_SUCCESS',
  'FETCH_SPECIMEN_REQUEST_ERROR',
  'FETCH_IMAGING_STUDY_REQUEST',
  'FETCH_IMAGING_STUDY_REQUEST_START',
  'FETCH_IMAGING_STUDY_REQUEST_SUCCESS',
  'FETCH_IMAGING_STUDY_REQUEST_ERROR',
  'FETCH_CONSENTS',
  'FETCH_CONSENTS_START',
  'FETCH_CONSENTS_SUCCESS',
  'FETCH_CONSENTS_ERROR',
  'FETCH_GOAL',
  'FETCH_GOAL_START',
  'FETCH_GOAL_SUCCESS',
  'FETCH_GOAL_ERROR',
]);
